import { DColumns } from '../types';

export const DOWNLOAD_MESSAGE_ONE =
  'Your request will take several minutes to complete.<br><br>' +
  'You can download the finished file from the “Downloads and Exports” page found under your Profile menu.<br><br>' +
  'Once the download is complete, it will be available for 24 hours.';

export const DOWNLOAD_MESSAGE_TWO =
  'You can download the finished file from the “Downloads and Exports” page found under your Profile menu.<br><br>' +
  'Once the download is complete, it will be available for 24 hours.';

export const DOWNLOAD_MESSAGE_THREE =
  'Your request will take several minutes to complete.<br><br>' +
  'You can download the finished file from the “Downloads and Exports” page found under your Profile menu.<br><br>' +
  'Once the download is complete, it will be available for 24 hours.';

export const EXPORT_MESSAGE =
  'Your request will take several minutes to complete.<br><br>' +
  'You can download the finished file from the “Downloads and Exports” page found under your Profile menu.<br><br>' +
  'Once the export is complete, it will be available for 24 hours.';
export const downloadColumnSet: DColumns[] = [
  {
    blankHeader: true,
    key: 'action',
    label: 'Actions',
    type: 'default',
  },
  {
    blankHeader: false,
    key: 'file_name',
    label: 'File Name',
    type: 'default',
  },
  {
    blankHeader: false,
    key: 'status_field',
    label: 'Status',
    type: 'chip',
  },
  {
    blankHeader: false,
    key: 'requested_field',
    label: 'Requested',
    type: 'default',
  },
  {
    blankHeader: false,
    key: 'sponsor_field',
    label: 'Sponsor',
    type: 'default',
  },
  {
    blankHeader: false,
    key: 'sponsor_protocol_id_field',
    label: 'Sponsor Protocol ID',
    type: 'default',
  },
  {
    blankHeader: false,
    key: 'principal_investigator_field',
    label: 'Principal Investigator',
    type: 'default',
  },
];
export const exportColumnSet: DColumns[] = [
  {
    blankHeader: true,
    key: 'action',
    label: 'Actions',
    type: 'default',
  },
  {
    blankHeader: false,
    key: 'file_name',
    label: 'File Name',
    type: 'default',
  },
  {
    blankHeader: false,
    key: 'status_field',
    label: 'Status',
    type: 'chip',
  },
  {
    blankHeader: false,
    key: 'requested_field',
    label: 'Requested',
    type: 'default',
  },
];
